import React from 'react';

import { Text, useToast, HStack } from '@chakra-ui/react';
import { useMutation } from 'react-query';

import api from 'api';
import { Button, Icon } from 'components';

export default function ExportUsers({
  onSuccess = () => {},
  ...rest
}) {
  const toast = useToast();

  const {
    mutate,
    isLoading,
  } = useMutation(() => api().get('export'), {
    onSuccess: ({ data }) => {
      toast({
        title: 'Exportado com sucesso!',
        description: 'Verifique seus downloads!',
        status: 'success',
        duration: 5000,
        position: 'top-right',
        isClosable: true,
      });
      window.open(data);
      onSuccess();
    },
    onError: ({ errors }: {errors: any[]}) => {
      toast({
        title: 'Ocorreu um erro!',
        description: errors?.map(({ message }) => message),
        status: 'error',
        duration: 5000,
        position: 'top-right',
        isClosable: true,
      });
    },
  });
  return (
    <>
      <Button
        onClick={() => mutate()}
        mr={4}
        isLoading={isLoading}
        size="xs"
        _hover={{ bg: 'gray.200' }}
        bg="white"
        {...rest}>
        <HStack>
          <Text
            variant="xSmallBold"
            color="gray.500">
            Exportar como .csv
          </Text>
          <Icon
            color="gray.500"
            name="file-download"
          />
        </HStack>
      </Button>
    </>
  );
}
